import React from 'react';
import classNames from 'classnames';

import { useAuthContext } from '../../hooks/auth/useAuthContext';
import {
  DEFAULT_SUBJECT_GROUP_SOLUTION_TOOLS,
  SUBJECT_GROUP_SOLUTION_TOOLS,
} from '../../utilities/constants/subject-group';
import styles from './SolutionTools.module.scss';
import Icon from '../Icon';

import { useOpenSubscriptionPopup } from '../../hooks/popup/useOpenSubscriptionPopup';
import { dataLayerGA } from '../../services/analytics/dataLayerGa';

interface Props {
  subjectGroup?: string;
}

const SolutionTools: React.FC<Props> = ({ subjectGroup }) => {
  const { isUserSubscribed } = useAuthContext();
  const { handleOpenSubscriptionPopup } = useOpenSubscriptionPopup();
  const tools =
    (subjectGroup && SUBJECT_GROUP_SOLUTION_TOOLS[subjectGroup]) ||
    DEFAULT_SUBJECT_GROUP_SOLUTION_TOOLS;

  const handleToolClick = (name: string) => {
    dataLayerGA.solutionToolClick(name);

    if (isUserSubscribed) return;

    handleOpenSubscriptionPopup();
  };

  return (
    <div
      className={classNames(
        styles.toolsContent,
        'd-flex gap-md flex-wrap@md flex-jc-c@md gap-xs'
      )}>
      {tools.map((tool) => (
        <div
          key={`${tool.name}`}
          className={classNames('w-100', styles.toolWrapper)}>
          <a
            className={classNames(
              styles.tool,
              'd-flex flex-col@md gap-xs td-none w-100'
            )}
            href={
              isUserSubscribed
                ? `${process.env.REACT_APP_WP_DOMAIN_LINK}/${tool.url}`
                : undefined
            }
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => handleToolClick(tool.name)}>
            <Icon glyph={tool.icon} />

            <span
              className={classNames(
                styles.toolButtonText,
                'text-sm fw-bold ta-left'
              )}>
              {tool.name}
            </span>
          </a>
        </div>
      ))}
    </div>
  );
};

export default SolutionTools;
